// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .loading-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.7);
      z-index: 1000;
    }
    
    .clickable-count {
      color: #007bff;
      text-decoration: none;
      cursor: pointer;
    }
    
    .clickable-count:hover {
      text-decoration: underline;
      color: #0056b3;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/analytics/sales-analytics.component.ts"],"names":[],"mappings":";IACI;MACE,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,WAAW;MACX,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,0CAA0C;MAC1C,aAAa;IACf;;IAEA;MACE,cAAc;MACd,qBAAqB;MACrB,eAAe;IACjB;;IAEA;MACE,0BAA0B;MAC1B,cAAc;IAChB","sourcesContent":["\n    .loading-overlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: rgba(255, 255, 255, 0.7);\n      z-index: 1000;\n    }\n    \n    .clickable-count {\n      color: #007bff;\n      text-decoration: none;\n      cursor: pointer;\n    }\n    \n    .clickable-count:hover {\n      text-decoration: underline;\n      color: #0056b3;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
